import { Injectable } from '@angular/core';
import { RestApiService } from './rest-api.service';
import { StateOfCar } from '../interfaces/state-of-car';

@Injectable({
  providedIn: 'root'
})
export class StateOfCarService {

  stateOfCars: Array<StateOfCar> = [];
  stateOfCarCount: number = 0;

  constructor(
    private api: RestApiService
  ) {}

  getStateOfCarCount() : number {
    return this.stateOfCarCount;
  };

  setStateOfCars(stateOfCars) : void {
    this.stateOfCars = stateOfCars;
    this.stateOfCarCount = this.stateOfCars.length;
  };

  getManagerStateOfCarById(id : number) : Promise<any> {
    return new Promise((resolve, reject) => {
      this.api.get('/MI_Galago/WCF_MI_Galago/REST/vop/manager-state-of-car/' + id, {}, true).then((res) => {
        resolve(res);
      });
    });
  };

  getStateOfCarById(id : number) : Promise<any> {
    return new Promise((resolve, reject) => {
      this.api.get('/MI_Galago/WCF_MI_Galago/REST/vop/state-of-car/' + id, {}, true).then((res) => {
        resolve(res);
      });
    });
  };

  getManagerStateOfCarByVehicle(id : number) : Promise<any> {
    return new Promise((resolve, reject) => {
      this.api.get('/MI_Galago/WCF_MI_Galago/REST/vop/vehicle/' + id + '/manager-state-of-car', {}, true).then((res) => {
        if (typeof res === 'object' && res.length > 0) {
          resolve(res.reverse());
          return;
        }
        resolve(res);
      });
    });
  };

  getStateOfCarByVehicle(id : number) : Promise<any> {
    return new Promise((resolve, reject) => {
      this.api.get('/MI_Galago/WCF_MI_Galago/REST/vop/vehicle/'+ id + '/state-of-car', {}, true).then((res) => {
        if (typeof res === 'object' && res.length > 0) {
          resolve(res.reverse());
          return;
        }
        resolve(res);
      });
    });
  };

  updateStateOfCarByDates(start, end, status) : Promise<any> {
    return new Promise((resolve, reject) => {
      this.api.get('/MI_Galago/WCF_MI_Galago/REST/vop/back-office/state-of-car', {
        dateStart: start + 'T00:00:00.000Z',
        dateEnd: end + 'T23:59:59.999Z',
        status: status
      }, true).then((res) => {
        if (typeof res === 'object' && res.length > 0)
          this.setStateOfCars(res);
        resolve(res.reverse());
      });
    });
  };

  updateSinisterState(id, state) : Promise<any> {
    return new Promise((resolve, reject) => {
      this.api.post('/MI_Galago/WCF_MI_Galago/REST/vop/vehicle/updateStateOfCarState', {
        _idStateOfCar: id,
        _state: state
      }, false).then((res) => {
        resolve(res);
      });
    });
  };

  addManagerStateOfCar(state : {
    photo: any,
    id_vehicle: number,
    part: number,
    location: string,
    description: string,
    supported: string,
    provider: string
  }) : Promise<any> {
    return new Promise((resolve, reject) => {
      let formData = new FormData();

      formData.append('id_vehicle', state.id_vehicle.toString());
      formData.append('photo', state.photo);
      formData.append('part', state.part.toString());
      formData.append('location', state.location);
      formData.append('description', state.description);
      formData.append('supported', state.supported);
      formData.append('provider', state.provider);
      this.api.post('/MI_Galago/WCF_MI_Galago/REST/vop/manager-state-of-car', formData, false).then((res) => {
        resolve(res);
      });
    });
  };

  updateManagerStateOfCar(state : {
    id_manager_state_car: number,
    title: string,
    comment: string,
    state: number,
    photo?: any,
  }) : Promise<any> {
    return new Promise((resolve, reject) => {
      let formData = new FormData();

      formData.append('id_manager_state_car', state.id_manager_state_car.toString());
      formData.append('photo', state.photo);
      formData.append('location', state.title);
      formData.append('description', state.comment);
      formData.append('state', state.state.toString());
      this.api.put('/MI_Galago/WCF_MI_Galago/REST/vop/manager-state-of-car', formData, false).then((res) => {
        resolve(res);
      });
    });
  }
}
